interface RankItem {
  rank: number;
  title: string;
  tag: string;
  tagType: '韩漫' | '日漫' | '国漫';
  heat: string;
  trend: 'up' | 'down' | 'stable';
}

const RANKING: RankItem[] = [
  { rank: 1, title: '我独自升级', tag: '韩漫', tagType: '韩漫', heat: '892万', trend: 'up' },
  { rank: 2, title: '咒术回战', tag: '日漫', tagType: '日漫', heat: '765万', trend: 'up' },
  { rank: 3, title: '一人之下', tag: '国漫', tagType: '国漫', heat: '698万', trend: 'stable' },
  { rank: 4, title: '外貌至上主义', tag: '韩漫', tagType: '韩漫', heat: '587万', trend: 'up' },
  { rank: 5, title: '间谍过家家', tag: '日漫', tagType: '日漫', heat: '498万', trend: 'down' },
  { rank: 6, title: '镇魂街', tag: '国漫', tagType: '国漫', heat: '542万', trend: 'stable' },
];

export default function RankingSection() {
  const trendIcon = (trend: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>;
    if (trend === 'down') return <i className="ri-arrow-down-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>;
    return <i className="ri-subtract-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>;
  };

  const rankColor = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-background-50';
    if (rank === 2) return 'bg-primary-500 text-background-50';
    if (rank === 3) return 'bg-secondary-500 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  const tagStyle = (type: string) => {
    if (type === '韩漫') return 'bg-accent-100 text-accent-700';
    if (type === '日漫') return 'bg-primary-100 text-primary-700';
    return 'bg-secondary-100 text-secondary-700';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">热门排行</h2>
          <p className="text-foreground-500 text-sm mt-3">全网读者票选热门漫画，实时热度排行榜</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
            <div className="grid grid-cols-12 gap-3 px-5 py-3 bg-background-200/50 text-xs font-medium text-foreground-500">
              <div className="col-span-2 text-center">排名</div>
              <div className="col-span-5">作品</div>
              <div className="col-span-2 text-center">分类</div>
              <div className="col-span-2 text-center">热度</div>
              <div className="col-span-1 text-center">趋势</div>
            </div>
            {RANKING.map((item) => (
              <div
                key={item.rank}
                className="grid grid-cols-12 gap-3 px-5 py-4 border-b border-background-200/50 last:border-b-0 hover:bg-background-50 transition-colors items-center"
              >
                <div className="col-span-2 flex justify-center">
                  <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${rankColor(item.rank)}`}>
                    {item.rank}
                  </span>
                </div>
                <div className="col-span-5 font-medium text-sm text-foreground-800">{item.title}</div>
                <div className="col-span-2 flex justify-center">
                  <span className={`text-xs px-2 py-0.5 rounded-md font-medium ${tagStyle(item.tagType)}`}>{item.tag}</span>
                </div>
                <div className="col-span-2 text-center text-sm text-foreground-600 font-medium">{item.heat}</div>
                <div className="col-span-1 flex justify-center">{trendIcon(item.trend)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}